import { render, staticRenderFns } from "./BlockSettingsSheet.vue?vue&type=template&id=187edbd9&scoped=true"
import script from "./BlockSettingsSheet.vue?vue&type=script&lang=js"
export * from "./BlockSettingsSheet.vue?vue&type=script&lang=js"
import style0 from "./BlockSettingsSheet.vue?vue&type=style&index=0&id=187edbd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187edbd9",
  null
  
)

export default component.exports